
import { useContextSafe } from '@utils/useContextSafe';
import { useAddMatrixRowMutation, useRemoveMatrixRowMutation } from 'gql/index';
import { useCallback } from 'react';
import { FormFillerContext } from '../../FormFillerContextProvider';
import { useFormFillerHelpers } from '../../useFormFillerHelpers';

export const useMatrixRowFiller = () => {
  const { submissionId } = useContextSafe(FormFillerContext);

  const { onFormFillSaving, onFormFillSuccess: onSuccess, onFormFillError: onError } = useFormFillerHelpers();

  const { mutateAsync: addNewRowMutate, isPending: isAddingRow } = useAddMatrixRowMutation({ onSuccess, onError });

  const { mutateAsync: deleteRowMutate, isPending: isDeletingRow } = useRemoveMatrixRowMutation({ onSuccess, onError });

  const deleteRow = useCallback((rowId: number, matrixFieldId: number) => {
    onFormFillSaving();

    return deleteRowMutate({ input: { rowId, matrixFieldId, submissionId } });
  }, [deleteRowMutate, onFormFillSaving, submissionId]);

  const addNewRow = useCallback(async (matrixFieldId: number) => {
    onFormFillSaving();
    const result = await addNewRowMutate({ input: { matrixFieldId, submissionId } });
    return result.addMatrixRow.matrixRow?.id;
  }, [addNewRowMutate, onFormFillSaving, submissionId]);

  const isAddRowLoading = isAddingRow;
  const isRemoveRowLoading = isDeletingRow;

  return { addNewRow, deleteRow, isAddRowLoading, isRemoveRowLoading };
};